module.exports = __webpack_public_path__ + "img/right-5.93330433.jpg";